import React, { useRef } from "react";
import { Link } from "react-router-dom";
import methodModel from "../../../methods/methods";
import Sidebar from "../sidebar";
import { Menu, Transition } from "@headlessui/react";
import { Fragment, useEffect, useState } from "react";
import { FaRegUser } from "react-icons/fa";
import { IoSettingsOutline } from "react-icons/io5";
import { FiMenu, FiX, FiLogOut, FiChevronDown, FiUser, FiLock, FiEdit3 } from "react-icons/fi";
import ApiClient from "./../../../methods/api/apiClient";
import { useNavigate } from "react-router-dom";
import { SidebarItems } from "../../../utils/constants";
import { useDispatch, useSelector } from "react-redux";

const Html = ({
  isOpen,
  toggle,
  searchHandle,
  search,
  user,
  unreadCount,
  isOpen1,
  searchChange,
  clear,
  Logout,
  setIsOpen,
}) => {
  const Navigate = useNavigate();
  const SubsciptionData = useSelector((state) => state.Subscription);

  const PlanFeatureAvailable = (feature = "") => {
    let data = SubsciptionData;
    return data?.includes(feature);
  };
  const WebDetails = useSelector((state) => state.logo);
  const [AllNotifications, setAllNotifications] = useState([]);
  const [NotificationCount, setNotificationCount] = useState(0);
  const CurrentServer = true;
  const [PinnedStates, setPinnedStates] = useState(null);
  useEffect(() => {
    if (user?.pinnedTabs && CurrentServer) {
      setPinnedStates([...user?.pinnedTabs]);
    } else {
      setPinnedStates([]);
    }
  }, [user]);
  const PathName = window.location.pathname;

  const [isChatbotVisible, setIsChatbotVisible] = useState(false);
  const [notificationOpen, setNotificationOpen] = useState(false);
  const handleNotificationToggle = () => {
    setNotificationOpen((prev) => !prev);
  };
  const notificationRef = useRef(null);

  // Close notification panel when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        notificationRef.current &&
        !notificationRef.current.contains(event.target) &&
        notificationOpen
      ) {
        setNotificationOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [notificationOpen, setNotificationOpen]);

  const handleToggleVisibility = () => {
    setIsChatbotVisible((prev) => !prev);
  };

  const handleCloseChatbot = () => {
    setIsChatbotVisible(false);
  };

  const history = useNavigate();

  const GetSidebarData = (data) => {
    SidebarItems?.find((item) => {
      if (item?.name == data) {
        return item?.icon || item?.name;
      }
    });
  };
  const logo = () => {
    let value = WebDetails?.logo;
    return value;
  };
  const logos = () => {
    let value = "/assets/img/logo.png";
    return value;
  };

  const [AccessedAccount, setAccessedAccount] = useState([]);
  const GetAccountsAccess = () => {
    ApiClient.get(`api/user/account/access?id=${user?._id || user?.id}`).then(
      (res) => {
        if (res?.success) {
          setAccessedAccount(res?.data);
        }
      },
    );
  };

  const LoggedInUser = methodModel.CookieUtil.getCookie("loggedInUser")
    ? JSON.parse(methodModel.CookieUtil.getCookie("loggedInUser"))
    : {};
  const formatAdminName = (name) => {
    if (!name) return "Charles Smith & Associates Admin";
    return name.replace(/iknow\s*admin/gi, "Charles Smith & Associates Admin").replace(/iknow/gi, "Charles Smith & Associates");
  };

  return (
    <nav
      className={`w-full ${
        isOpen ? "lg:w-[calc(100%_-_0px)]" : "lg:w-[calc(100%_-_280px)]"
      } header-class shadow-sm h-[72px] flex items-center bg-white fixed transition-[width] duration-300 ml-auto right-0 left-0 lg:left-auto z-40 !px-4 sm:!px-6 border-b border-slate-200`}
    >
      <div className="flex items-center justify-end gap-3 w-full">
        {/* <div className="flex items-center">
          <button
            onClick={toggle}
            className="h-9 w-9 shrink-0 shadow-btn hover:shadow-none p-1 rounded-lg border border-gray-100 !text-[#115B9D]  ">
            {isOpen ? (
              <FiMenu className="w-full h-full" />
            ) : (
              <FiX className="w-full h-full" />
            )}
          </button>
        </div> */}
        <div>
          <Menu as="div" className="relative z-10 flex items-center">
            <Menu.Button className="group flex items-center gap-2.5 px-3 py-1.5 rounded-xl border border-slate-200/90 bg-white hover:bg-slate-50 hover:border-slate-300 transition-all shadow-xs focus:outline-none cursor-pointer">
              <img
                alt={formatAdminName(user?.fullName)}
                src={methodModel.userImg(user?.image)}
                className="object-cover w-8 h-8 rounded-lg border border-slate-200 shadow-2xs"
              />
              <div className="text-left hidden sm:block">
                <p className="capitalize font-black text-slate-800 text-xs leading-tight">
                  {formatAdminName(user?.fullName)}
                </p>
                <p className="text-[10px] font-bold text-slate-700 uppercase tracking-wider">
                  {user?.role?.name || "Super Admin"}
                </p>
              </div>
              <FiChevronDown className="w-4 h-4 text-slate-600 group-hover:text-slate-900 transition-transform group-aria-expanded:rotate-180" />
            </Menu.Button>

            <Transition
              as={Fragment}
              enter="transition ease-out duration-150"
              enterFrom="transform opacity-0 scale-95 -translate-y-1"
              enterTo="transform opacity-100 scale-100 translate-y-0"
              leave="transition ease-in duration-100"
              leaveFrom="transform opacity-100 scale-100 translate-y-0"
              leaveTo="transform opacity-0 scale-95 -translate-y-1"
            >
              <Menu.Items className="absolute right-0 top-12 z-[9999] mt-2 w-72 origin-top-right rounded-2xl bg-white shadow-[0_16px_45px_rgba(0,0,0,0.12)] border border-slate-200/90 focus:outline-none overflow-hidden divide-y divide-slate-100">
                {/* 1. Profile Header with Identity & Role */}
                <div className="p-4 bg-gradient-to-br from-slate-50 via-sky-50/40 to-slate-50 border-b border-slate-100">
                  <div className="flex items-center gap-3">
                    <img
                      src={methodModel.userImg(user?.image)}
                      className="w-11 h-11 rounded-xl object-cover border-2 border-white shadow-sm shrink-0"
                      alt={formatAdminName(user?.fullName)}
                    />
                    <div className="min-w-0 flex-1">
                      <p className="text-sm font-black text-slate-900 truncate">
                        {formatAdminName(user?.fullName)}
                      </p>
                      <p className="text-xs text-slate-700 font-mono truncate">
                        {user?.email || "superadmin@yopmail.com"}
                      </p>
                    </div>
                  </div>
                  <div className="mt-3 flex items-center justify-between pt-2 border-t border-slate-200/60">
                    <span className="inline-flex items-center gap-1.5 px-2.5 py-0.5 rounded-full bg-emerald-50 border border-emerald-200 text-[10px] font-black uppercase tracking-wider text-emerald-700">
                      <span className="w-1.5 h-1.5 rounded-full bg-emerald-500 animate-pulse" />
                      {user?.role?.name || "Super Admin"}
                    </span>
                    <span className="text-[10px] font-bold uppercase tracking-wider text-slate-700">
                      Super Admin
                    </span>
                  </div>
                </div>

                {/* 2. Menu Navigation Links */}
                <div className="p-2 space-y-0.5">
                  <Menu.Item>
                    {({ active }) => (
                      <Link
                        to={
                          user?.role?.name === "Affiliate"
                            ? "/affiliate/profile"
                            : "/profile"
                        }
                        className={`flex items-center gap-3 px-3 py-2.5 rounded-xl text-xs font-bold transition-all ${
                          active ? "bg-[#115B9D]/10 text-[#115B9D]" : "text-slate-700 hover:text-slate-900"
                        }`}
                      >
                        <div
                          className={`w-8 h-8 rounded-lg flex items-center justify-center transition-colors shrink-0 ${
                            active ? "bg-[#115B9D] text-white" : "bg-slate-100 text-slate-600"
                          }`}
                        >
                          <FiUser className="w-4 h-4" />
                        </div>
                        <div className="flex-1 min-w-0">
                          <div className="font-black text-slate-900 leading-tight">View Profile</div>
                          <div className="text-[10px] text-slate-700 font-medium truncate mt-0.5">
                            Account identity & security status
                          </div>
                        </div>
                      </Link>
                    )}
                  </Menu.Item>

                  <Menu.Item>
                    {({ active }) => (
                      <Link
                        to="/profile/edit"
                        className={`flex items-center gap-3 px-3 py-2.5 rounded-xl text-xs font-bold transition-all ${
                          active ? "bg-[#115B9D]/10 text-[#115B9D]" : "text-slate-700 hover:text-slate-900"
                        }`}
                      >
                        <div
                          className={`w-8 h-8 rounded-lg flex items-center justify-center transition-colors shrink-0 ${
                            active ? "bg-[#115B9D] text-white" : "bg-slate-100 text-slate-600"
                          }`}
                        >
                          <FiEdit3 className="w-4 h-4" />
                        </div>
                        <div className="flex-1 min-w-0">
                          <div className="font-black text-slate-900 leading-tight">Edit Profile</div>
                          <div className="text-[10px] text-slate-700 font-medium truncate mt-0.5">
                            Update photo, name & contact info
                          </div>
                        </div>
                      </Link>
                    )}
                  </Menu.Item>

                  <Menu.Item>
                    {({ active }) => (
                      <Link
                        to="/change-password"
                        className={`flex items-center gap-3 px-3 py-2.5 rounded-xl text-xs font-bold transition-all ${
                          active ? "bg-[#115B9D]/10 text-[#115B9D]" : "text-slate-700 hover:text-slate-900"
                        }`}
                      >
                        <div
                          className={`w-8 h-8 rounded-lg flex items-center justify-center transition-colors shrink-0 ${
                            active ? "bg-[#115B9D] text-white" : "bg-slate-100 text-slate-600"
                          }`}
                        >
                          <FiLock className="w-4 h-4" />
                        </div>
                        <div className="flex-1 min-w-0">
                          <div className="font-black text-slate-900 leading-tight">Change Password</div>
                          <div className="text-[10px] text-slate-700 font-medium truncate mt-0.5">
                            Manage password authentication
                          </div>
                        </div>
                      </Link>
                    )}
                  </Menu.Item>
                </div>

                {/* 3. Logout Action */}
                <div className="p-2">
                  <Menu.Item>
                    {({ active }) => (
                      <button
                        onClick={() => Logout()}
                        className={`flex w-full items-center gap-3 px-3 py-2.5 rounded-xl text-xs font-bold transition-all text-left cursor-pointer ${
                          active ? "bg-red-50 text-red-600" : "text-red-600 hover:bg-red-50/70"
                        }`}
                      >
                        <div className="w-8 h-8 rounded-lg bg-red-100/70 text-red-600 flex items-center justify-center shrink-0">
                          <FiLogOut className="w-4 h-4" />
                        </div>
                        <div className="flex-1 min-w-0">
                          <div className="font-black text-red-600 leading-tight">Sign Out</div>
                          <div className="text-[10px] text-red-600/80 font-medium truncate mt-0.5">
                            End administrator session safely
                          </div>
                        </div>
                      </button>
                    )}
                  </Menu.Item>
                </div>
              </Menu.Items>
            </Transition>
          </Menu>
        </div>
      </div>
    </nav>
  );
};

export default Html;
